import type { ImAccount } from '@fruitful/types';
import * as React from 'react';
import { Animations, Notice, View } from 'smoothie';

import {
    findPairedRothAccountForBackdoorTrad,
    isBackdoorTraditionalIraContributionContext,
} from './backdoorTradIctDepositUtils';

export const shouldShowBackdoorTradConversionNotice = (
    fundedAccount: ImAccount | null | undefined,
): boolean => isBackdoorTraditionalIraContributionContext(fundedAccount);

interface BackdoorTradIctDepositConversionNoticeProps {
    traditionalIraAccount: ImAccount | null | undefined;
    apexAccounts: ImAccount[] | undefined;
}

export const BackdoorTradIctDepositConversionNotice = ({
    traditionalIraAccount,
    apexAccounts,
}: BackdoorTradIctDepositConversionNoticeProps) => {
    if (traditionalIraAccount == null) {
        return null;
    }

    const pairedRoth = findPairedRothAccountForBackdoorTrad(
        traditionalIraAccount,
        apexAccounts,
    );

    const description =
        pairedRoth != null
            ? `Contributions to this IRA are part of a backdoor Roth conversion strategy. Deposits are automatically converted to your Roth IRA ${pairedRoth.nickname} (account number ${pairedRoth.accountNumber}).`
            : 'Contributions to this IRA are part of a backdoor Roth conversion strategy. Deposits are automatically converted to your paired Roth IRA.';

    return (
        <View {...Animations.FadeInFromAbove}>
            <Notice
                variant="neutral"
                title="Automatic Roth conversion"
                description={description}
            />
        </View>
    );
};
